import React from 'react'
import BlockForm from '../../Admin/Pages/Blocks/BlockForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCog } from '@fortawesome/pro-duotone-svg-icons/faCog'
import { CompactButton } from '@/Components/Elements/StyledComponents/Buttons'

export default class BlockEditButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            edit: false,
            size: this.props.size ? this.props.size : 'sm',
        }
    }

    render() {
        return (
            <div>
                {this.state.edit ? (
                    <BlockForm
                        variant={'edit'}
                        item={this.props.item}
                        kedo={this.props.kedo}
                        handleClose={this.props.handleClose}
                        onClose={() => this.setState({ edit: false })}
                        onSuccess={() => {
                            this.setState({ edit: false })
                            this.props.onSuccess()
                        }}
                    />
                ) : null}
                <CompactButton
                    size={this.state.size}
                    sx={{ float: 'right' }}
                    onClick={() => this.setState({ edit: true })}
                >
                    <FontAwesomeIcon icon={faCog} />
                </CompactButton>
            </div>
        )
    }
}
